/**
 * Defines acceptable ranges for environmental values like temperature and humidity
 */

// Temperature ranges in Celsius
export const TEMPERATURE_RANGES = {
  LOW: { min: -Infinity, max: 23 },  // Below 20°C is considered low/cold
  NORMAL: { min: 23, max: 30 },      // 20-26°C is the normal/comfortable range
  HIGH: { min: 30, max: Infinity }   // Above 26°C is considered high/hot
};

// Relative Humidity ranges in percentage
export const HUMIDITY_RANGES = {
  LOW: { min: -Infinity, max: 40 },  // Below 40% is considered low
  NORMAL: { min: 40, max: 60 },      // 40-60% is the normal/comfortable range
  HIGH: { min: 60, max: Infinity }   // Above 60% is considered high
};

/**
 * Determines the range category for a temperature value
 * @param value Temperature in Celsius
 * @returns 'LOW', 'NORMAL', or 'HIGH'
 */
export function getTemperatureRange(value: number): 'LOW' | 'NORMAL' | 'HIGH' {
  if (value < TEMPERATURE_RANGES.NORMAL.min) return 'LOW';
  if (value > TEMPERATURE_RANGES.NORMAL.max) return 'HIGH';
  return 'NORMAL';
}

/**
 * Determines the range category for a humidity value
 * @param value Relative humidity percentage
 * @returns 'LOW', 'NORMAL', or 'HIGH'
 */
export function getHumidityRange(value: number): 'LOW' | 'NORMAL' | 'HIGH' {
  if (value < HUMIDITY_RANGES.NORMAL.min) return 'LOW';
  if (value > HUMIDITY_RANGES.NORMAL.max) return 'HIGH';
  return 'NORMAL';
}
